import { ColumnType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { Table } from "../../../components/Table/Table";
import { IzvestajiOPrometuVeletrgovina } from "../../../modules/trackAndTrace/trackAndTrace.types";
import { PaginationPayload } from "../../../types";

const VeletrgovinaTable = ({
  veletrgovina,
  pagination,
  setPagination,
  totalCount,
}: {
  veletrgovina: IzvestajiOPrometuVeletrgovina[];
  pagination: PaginationPayload;
  setPagination: (pagination: PaginationPayload) => void;
  totalCount: number;
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("TRACK.NAZIV_PRIVREDNOG_SUBJEKTA"),
      dataIndex: "ime",
      key: "ime",
      width: 250,
    },
    {
      title: t("TRACK.PIB"),
      dataIndex: "pib",
      key: "pib",
      width: 150,
    },
    {
      title: t("TRACK.NAZIV_MALOPRODAJE"),
      dataIndex: "nazivMaloprodaje",
      key: "nazivMaloprodaje",
      width: 200,
    },
    {
      title: t("TRACK.PIB_MALOPRODAJE"),
      dataIndex: "pibMaloprodaje",
      key: "pibMaloprodaje",
      width: 150,
    },
    {
      title: t("TRACK.PRIMLJENO"),
      dataIndex: "primljeno",
      key: "primljeno",
      width: 150,
    },
    {
      title: t("TRACK.POSLATO"),
      dataIndex: "poslato",
      key: "poslato",
      width: 150,
    },
    {
      title: t("TRACK.UNISTENO"),
      dataIndex: "unisteno",
      key: "unisteno",
      width: 150,
    },
    {
      title: t("TRACK.UKUPNA_KOLICINA"),
      dataIndex: "ukupnaKolicina",
      key: "ukupnaKolicina",
      width: 150,
    },
    {
      title: t("TRACK.STANJE_NA_ZALIHAM"),
      dataIndex: "stanjeNaZalihama",
      key: "stanjeNaZalihama",
      width: 200,
    },
  ] as ColumnType<IzvestajiOPrometuVeletrgovina>[];

  return (
    <Table
      name="veletrgovina"
      dataSource={veletrgovina}
      columns={columns}
      rowKey="id"
      scrollConfig={[
        ".ant-tabs-nav-wrap",
        ".ant-pagination",
        "#izvestaji-o-prometu-filters",
      ]}
      pagination={{
        total: totalCount,
        pageSize: pagination.pageSize,
        current: pagination.pageNumber,
        onChange(page: number, pageSize: number) {
          setPagination({
            pageNumber: page,
            pageSize: pageSize,
          });
        },
      }}
    />
  );
};

export default VeletrgovinaTable;
